{
  "locale": "Svenska",
  "sidebar": {
    "title": "Begäran om datadelning",
    "issuanceTitle": "Begäran om att lägga till uppgifter",
    "authenticationTitle": "Autentiseringsbegäran",
    "description": "{clientName} begär verifierade personuppgifter från din identitetsapp. Granska detaljerna nedan och godkänn eller avslå denna begäran i din identitetsapp.",
    "issuanceDescription": "{clientName} lägger till verifierade uppgifter i din identitetsapp. Granska detaljerna nedan och bekräfta i din identitetsapp om du vill acceptera.",
    "authenticationDescription": "{clientName} vill autentisera med din identitetsapp.",
    "descriptionFallback": "En tjänst begär verifierade personuppgifter från din identitetsapp. Granska detaljerna nedan och godkänn eller avslå denna begäran i din identitetsapp.",
    "issuanceDescriptionFallback": "En tjänst lägger till verifierade uppgifter i din identitetsapp. Granska detaljerna nedan och bekräfta i din identitetsapp om du vill acceptera.",
    "authenticationDescriptionFallback": "En tjänst vill autentisera med din identitetsapp.",
    "stepsTitle": "Steg att slutföra",
    "stepShareData": "Dela uppgifter med {clientName}",
    "stepAuthenticate": "Autentisera för {clientName}",
    "stepReceiveData": "Ta emot uppgifter från {clientName}",
    "stepGeneric": "Slutför de nödvändiga stegen",
    "defaultClientName": "tjänsten",
    "requestedDataTitle": "Följande uppgifter begärs",
    "issuedDataTitle": "Följande uppgifter kommer att utfärdas",
    "reviewNotice": "Du granskar och godkänner de exakta uppgifterna i din identitetsapp innan något delas.",
    "issuanceReviewNotice": "Du granskar och godkänner de exakta uppgifterna i din identitetsapp innan något läggs till.",
    "indeterminateHint": "De begärda uppgifterna blir synliga efter att du har valt en identitetsapp",
    "terms": "Villkor",
    "termsLink": "Villkor",
    "privacyLink": "Integritetspolicy",
    "showAll": "Visa alla",
    "purposeStatementTitle": "Varför dina uppgifter behövs",
    "retentionPolicyTitle": "Hur dina uppgifter hanteras"
  },
  "footer": {
    "powered": "Drivs av",
    "terms": "Villkor"
  },
  "topBar": {
    "openMenu": "Öppna meny",
    "closeMenu": "Stäng meny",
    "help": "Hjälp",
    "language": "Språk"
  },
  "app": {
    "error": "Fel",
    "loadingTitle": "Laddar",
    "loadingHint": "Ett ögonblick"
  },
  "language": {
    "en": "English",
    "nl": "Nederlands",
    "de": "Deutsch",
    "fr": "Français",
    "sv": "Svenska",
    "es": "Español",
    "search": "Sök",
    "noResults": "Inga resultat"
  },
  "init": {
    "title": "Behandlar begäran",
    "hint": "Din session förbereds"
  },
  "pairing": {
    "title": "Förbereder nästa steg",
    "hint": "Din session förbereds",
    "codeLabel": "Verifiera följande kod i din identitetsapp",
    "confirm": "Bekräfta parkoppling"
  },
  "waitingForPresentation": {
    "title": "Fortsätt i din identitetsapp",
    "hint": "Vänligen kontrollera din identitetsapp för att granska och godkänna begäran"
  },
  "agentStart": {
    "title": "Fortsätt i {appName}",
    "subtitle": "För att säkert dela dina uppgifter, skanna denna QR-kod med {appName} för att granska och godkänna begäran.",
    "issuanceSubtitle": "För att säkert ta emot uppgifterna, skanna denna QR-kod med {appName} för att granska och godkänna begäran.",
    "step1": "Öppna {appName}",
    "step2": "Klicka på skannerikonen",
    "step3": "Skanna denna QR-kod",
    "changeApp": "Byt identitetsapp",
    "installInstructions": "Installationsinstruktioner",
    "cancel": "Avbryt",
    "needHelp": "Behöver du hjälp?",
    "redirectSubtitle": "Klicka på knappen nedan för att öppna {appName} och godkänna begäran.",
    "issuanceRedirectSubtitle": "Klicka på knappen nedan för att öppna {appName} och godkänna begäran.",
    "redirectButton": "Fortsätt",
    "mobileSubtitle": "För att säkert dela dina uppgifter, fortsätt i {appName} för att granska och godkänna begäran.",
    "issuanceMobileSubtitle": "För att säkert ta emot uppgifterna, fortsätt i {appName} för att granska och godkänna begäran.",
    "openApp": "Öppna {appName}",
    "showQr": "Visa QR-kod"
  },
  "done": {
    "disclosure": {
      "title": "Uppgifterna har delats framgångsrikt",
      "subtitle": "Sidan stängs automatiskt om några sekunder.",
      "subtitleCloseTab": "Uppgifterna har delats. Du kan stänga denna sida."
    },
    "issuance": {
      "title": "Uppgifterna har mottagits",
      "subtitle": "Sidan stängs automatiskt om några sekunder.",
      "subtitleCloseTab": "Uppgifterna har mottagits. Du kan stänga denna sida."
    },
    "redirecting": "Omdirigerar...",
    "completeRedirect": "Slutför och omdirigera",
    "redirectFailed": "Automatisk omdirigering fungerade inte. Tryck nedan för att fortsätta."
  },
  "abort": {
    "cancel": {
      "title": "Processen stoppad",
      "subtitle": "Du valde att stoppa processen. Du kan starta om när som helst."
    },
    "techFail": {
      "title": "Något gick fel",
      "subtitle": "Vi kunde inte slutföra processen på grund av ett tekniskt problem."
    },
    "timeout": {
      "title": "Sessionen har gått ut",
      "subtitle": "Denna session avslutades efter en period av inaktivitet. Stäng denna sida och starta om processen för att fortsätta."
    },
    "networkLoss": {
      "title": "Anslutningen förlorad",
      "subtitle": "Din internetanslutning avbröts. Kontrollera din anslutning och försök igen."
    },
    "backendDowntime": {
      "title": "Tjänsten är tillfälligt otillgänglig",
      "subtitle": "Tjänsten genomgår för närvarande underhåll. Försök igen senare."
    },
    "appUnavailable": {
      "title": "Identitetsappen är inte tillgänglig",
      "subtitle": "Vi kunde inte ansluta till den valda identitetsappen. Appen kan vara tillfälligt otillgänglig. Du kan prova en annan identitetsapp eller försöka igen senare."
    },
    "selectDifferentApp": "Välj en annan identitetsapp",
    "confirmTitle": "Stoppa processen?",
    "confirmMessage": "Är du säker på att du vill stoppa? Du kan starta om när som helst om du vill fortsätta senare.",
    "confirmCancel": "Avbryt",
    "confirmStop": "Stoppa processen",
    "goBack": "Gå tillbaka",
    "leave": "Lämna",
    "closePage": "Stäng sidan",
    "restart": "Starta om",
    "retry": "Försök igen"
  },
  "appPicker": {
    "title": "Stödda identitetsappar",
    "subtitle": "Följande identitetsappar kan användas för att granska och godkänna begäran",
    "searchPlaceholder": "Sök...",
    "sectionLastUsed": "Senast använd",
    "sectionRecommended": "Rekommenderad",
    "sectionAZ": "A-Ö",
    "noResults": "Inga appar matchar din sökning",
    "filterTitle": "Filtrera efter land",
    "filterClear": "Rensa alla",
    "filterDone": "Klar"
  },
  "faq": {
    "helpQuestion": "Fråga",
    "moreHelp": "Mer hjälp",
    "close": "Stäng",
    "whatAreWallets": {
      "title": "Vad är identitetsappar?",
      "body": "Med en identitetsapp har du kontroll över dina egna data — du bestämmer själv vilka data du delar, med vem och när. Dina data hämtas från en pålitlig och verifierad utfärdare och placeras i appen tillsammans med en digital signatur som garanterar att de är korrekta.\n\nNär du delar data med en tredje part skickas den digitala signaturen med så att mottagaren kan verifiera att uppgifterna är autentiska. Dina data lagras vanligtvis bara på din egen telefon och kan enkelt hämtas igen vid behov.\n\nVar alltid medveten om att det är ditt ansvar att noggrant välja med vem du delar dina data."
    },
    "whyNotSupported": {
      "title": "Varför stöds inte min identitetsapp?",
      "body": "Det kan hända att din specifika identitetsapp inte är tillgänglig eftersom mottagaren eller vår plattform för närvarande inte stöder den. Vi arbetar ständigt för att utöka vårt utbud av stödda appar.\n\nOm din app inte finns med på listan kan du alltid installera och använda en av de andra stödda identitetsapparna."
    },
    "howDataProtected": {
      "title": "Hur skyddas mina data?",
      "body": "Identitetsappar säkerställer att du alltid har kontroll över vem du delar dina data med och när. Dessa appar ger dig vanligtvis en översikt över vilka data du har delat, med vem och när.\n\nVer.iD skickar dina data direkt till mottagaren och kontrollerar bara att de har levererats korrekt. All data behandlas i enlighet med Allmänna dataskyddsförordningen (GDPR). Den mottagande parten tillämpar sina egna regler för skydd av dina data och kommer att kommunicera detta med dig.\n\nVar alltid medveten om att det är ditt ansvar att noggrant välja med vem du delar dina data."
    },
    "howObtainData": {
      "title": "Hur kan jag lägga till data i min app?",
      "body": "Varje identitetsapp har sitt eget sätt att samla in data. De flesta appar har en knapp för att lägga till data. I vissa fall kan det finnas kostnader.\n\nFölj instruktionerna i appen för att samla in dina data på ett säkert sätt. Du kan omdirigeras till myndighetswebbplatser eller behöva skanna dokument som pass eller körkort.\n\nOm du inte ser ett direkt sätt att lägga till rätt data, kontrollera appens dokumentation eller kontakta appleverantören. Du kan också prova en annan identitetsapp."
    },
    "whyRedirection": {
      "title": "Varför omdirigeras jag?",
      "body": "Vissa identitetsappar kräver en omdirigering till deras egen webbplats så att dina data delas i enlighet med deras standarder, i en miljö som du litar på.\n\nEfter framgångsrik delning omdirigeras du automatiskt tillbaka till Ver.iD, där dina uppgifter väntar på ditt godkännande innan de skickas till mottagaren. Ett digitalt kvitto finns vanligtvis i din identitetsapp.\n\nOm processen misslyckas eller avbryts omdirigeras du också tillbaka och kan ha möjlighet att försöka igen."
    }
  },
  "dataReview": {
    "title": "Vänligen granska uppgifterna",
    "subtitleDisclosure": "Innan du delar, ta en stund att granska uppgifterna som kommer att delas med {clientName}.",
    "subtitleIssuance": "Innan du accepterar, ta en stund att granska uppgifterna du kommer att ta emot från {clientName}.",
    "issuedBy": "Uppgifter utfärdade av",
    "attribute": "Attribut",
    "value": "Värde",
    "cancel": "Avbryt",
    "acceptShare": "Acceptera",
    "acceptReceive": "Acceptera",
    "unknownClient": "tjänsten",
    "loadingNames": "Laddar datanamn...",
    "errorLoadingNames": "Kunde inte ladda datanamn. Försök igen."
  },
  "mobileFlowStart": {
    "startVerification": "Fortsätt",
    "selectApp": "Välj identitetsapp"
  },
  "requestedDataModal": {
    "title": "Begärda uppgifter",
    "subtitle": "Du granskar och godkänner denna begäran i din identitetsapp.",
    "attribute": "Attribut",
    "description": "Beskrivning",
    "issuedBy": "Uppgifter utfärdade av",
    "close": "Stäng"
  },
  "demo": {
    "title": "Demomiljö",
    "description": "Du använder en interaktiv demo av Ver.iD. Denna miljö är avsedd enbart för demonstrationsändamål."
  },
  "installInstructions": {
    "title": "Installera {appName}",
    "subtitle": "Besök App Store eller Play Store på din telefon för att installera {appName} identitetsapp. Skanna koden för att direkt öppna butikssidan och installera appen.",
    "close": "Stäng",
    "unavailableTitle": "Instruktioner ej tillgängliga",
    "unavailableBody": "Tyvärr har vi inga installationsinstruktioner tillgängliga för denna app just nu. Försök att manuellt söka efter appen i appbutiken för att fortsätta."
  }
}
